import { useEffect, useState } from "react";
import { Link } from "react-router";
import { RelativeData, RelativeHelper } from "../../../to-be-removed/LocalData/General/RelativeData";
import { LoadingIndicator } from "../../ui-components/LoadingIndicator/LoadingIndicator";
import { Text } from "../Text/Text";

interface DataTableRelativesCellProps {
  relatives: RelativeData[];
}

/**
 * @deprecated
 */
export const DataTableRelativesCell = (props: DataTableRelativesCellProps) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    let itemsToLoad = 0;
    let itemsLoaded = 0;

    for (const relative of props.relatives) {
      if (relative.reference && !relative.reference.loaded) {
        itemsToLoad++;
        relative.reference.load().finally(() => {
          itemsLoaded++;
          if (mounted && itemsLoaded === itemsToLoad) {
            setLoading(false);
          }
        });
      }
    }

    setLoading(itemsToLoad > 0);
    return () => {
      mounted = false;
    };
  }, [props.relatives]);

  return loading ? (
    <LoadingIndicator />
  ) : (
    <div>
      {props.relatives
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((relative) => {
          const link = RelativeHelper.getRelativeLink(relative);
          if (RelativeHelper.canViewRelative(relative) && link) {
            return (
              <Link key={relative.id} to={link} style={{ textDecoration: "none" }}>
                <Text size="md" text={relative.name} trailingIcon="open_in_new" />
              </Link>
            );
          } else {
            return <Text key={relative.id} size="md" text={relative.name} />;
          }
        })}
    </div>
  );
};
